import React, { Component } from "react";
import { connect } from "react-redux";
import { updateTheme, fetchFonts } from "../actions/themeEditor_actions";

const TypographyContainer = WrappedComponent => {
    class TypographyContainer extends Component {
        constructor() {
            super();
        }

        componentDidMount = () => {
            if (this.props.fonts.status !== "success") {
                this.props.fetchFonts(this.props.orgId);
            }
        };

        render() {
            const { theme, updateTheme, fetchFonts } = this.props;
            if (!theme.colors) {
                return null;
            }
            return (
                <WrappedComponent
                    update={updateTheme}
                    refreshFonts={() => fetchFonts(this.props.orgId)}
                    {...this.props}
                />
            );
        }
    }

    const mapStateToProps = ({ theme }) => {
        return {
            theme: theme.attributes,
            originalTheme: theme.originalTheme,
            model: theme.model,
            fonts: theme.fonts.list,
            fontsFetching: theme.fonts.status !== "success"
        };
    };

    return connect(
        mapStateToProps,
        { updateTheme, fetchFonts }
    )(TypographyContainer);
};

export default TypographyContainer;
